export default "__VITE_ASSET__Bt1bhvLK__"